import React, { useRef } from "react";
import { Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { toast } from "react-toastify";
import api from "../../../../../../../../features/auth/axiosConfig";

interface ImportButtonProps {
  onImport: () => void;
  onLoading: (loading: boolean) => void;
}

const ImportButton: React.FC<ImportButtonProps> = ({ onImport, onLoading }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleImport = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        onLoading(true);
        const response = await api.post(`/app/v2/import_export`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.status === 201) {
          toast.success("File imported successfully");
          onImport();
        } else {
          toast.error("Failed to import file");
        }
      } catch (error) {
        console.error("Error importing file:", error);
        toast.error("Error importing file. Please try again.");
      } finally {
        onLoading(false);
        if (inputRef.current) {
          inputRef.current.value = "";
        }
      }
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => inputRef.current?.click()}
        style={{
          textTransform: "none",
          borderRadius: "8px",
          height: "40px",
          width: "150px",
          borderColor: "#4e73df",
          color: "#4e73df",
        }}
        startIcon={<CloudUploadIcon />}
      >
        Import
      </Button>
      <input ref={inputRef} type="file" style={{ display: "none" }} onChange={handleImport} accept=".csv,.xlsx,.xls" />
    </>
  );
};

export default ImportButton;
